module.exports = __webpack_public_path__ + "static/media/filter-close.9892e7a6.png";